import BaseFeature from '../../foundation/base/base';

class Filter extends BaseFeature {
	constructor(element) {
		super(element);

		this.initDomCache();

		this.el = element;
		this.ticking = false;
		this.filter = this.el;
		this.body = window.features.dom.body;
		this.filterTrigger = this.el.querySelectorAll('[data-js="filterTrigger"]');
		this.selectAll = this.el.querySelector('[data-js="selectAll"]');
		this.selectItem = this.el.querySelectorAll('[data-js="selectItem"]');
		this.selectItemSecond = this.el.querySelector('[data-js="selectItem"]');
		this.selectItemChecked = this.el.querySelectorAll('[checked="true"]');
		this.filterSave = document.querySelector('.m-filter__button');
		this.filterReset = document.querySelector('.m-filter__reset');
		this.filterContent = this.el.querySelectorAll('[data-js="filterContent"]');
		this.filterSections = document.querySelectorAll('.m-filter__section');
		this.addClick();
	}

	addClick() {
		// Click anywhere to close
		if (this.el) {
			document.addEventListener('click', (event) => {
				const specifiedElement = document.getElementById('filterDropdown');
				const isClickInside = specifiedElement.contains(event.target);
				if (document.querySelector('.m-filter__section.is-dropped')) {
					if (!isClickInside) {
						document.querySelector('.m-filter__section.is-dropped').classList.remove('is-dropped');
					}
				}
			});
		}

		// Open-Close state on dropdown
		this.filterTrigger.forEach((el) => {
			el.addEventListener('click', () => {
				const isDropped = el.parentNode.classList.contains('is-dropped');
				this.filterSections.forEach((filterItem) => {
					filterItem.classList.remove('is-dropped');
					filterItem.setAttribute('aria-expanded', 'false');
				});
				this.selectItem.forEach((filterItemInput) => {
					filterItemInput.setAttribute('tabindex', '-1');
				});
				if (!isDropped) {
					el.parentNode.classList.add('is-dropped');
					el.parentNode.setAttribute('aria-expanded', 'true');
					this.selectItem.forEach((filterItemInput) => {
						filterItemInput.setAttribute('tabindex', '0');
					});
				}
			});

			// Accessibility
			window.addEventListener('keyup', (e) => {
				const isFocused = document.activeElement === el;
				if (isFocused && e.keyCode === 13) {
					e.preventDefault();
					const isDropped = el.parentNode.classList.contains('is-dropped');
					this.filterSections.forEach((filterItem) => {
						filterItem.classList.remove('is-dropped');
						filterItem.setAttribute('aria-expanded', 'false');
					});
					this.selectItem.forEach((filterItemInput) => {
						filterItemInput.setAttribute('tabindex', '-1');
					});
					if (!isDropped) {
						el.parentNode.classList.add('is-dropped');
						el.parentNode.setAttribute('aria-expanded', 'true');
						this.selectItem.forEach((filterItemInput) => {
							filterItemInput.setAttribute('tabindex', '0');
						});
					}
				}
			});
		});

		// Selecting each input
		this.selectItem.forEach((el) => {
			el.addEventListener('click', () => {
				const numberofCheckedItems = this.isChecked();
				if (numberofCheckedItems === true) {
					el.parentNode.parentNode.parentNode.classList.add('has-search');
					document.querySelector('.m-filter').classList.add('has-buttons');
				} else {
					el.parentNode.parentNode.parentNode.classList.remove('has-search');
					document.querySelector('.m-filter').classList.remove('has-buttons');
				}
				this.log('ischecked: ', this.isChecked());
				this.selectAll.checked = false;
			});


			// Detecting active input on pageload
			if (this.selectItemChecked[0]) {
				this.filterReset.classList.add('is-reset');
				el.parentNode.parentNode.parentNode.classList.add('has-search');
				document.querySelector('.m-filter').classList.add('has-buttons');
			}
		});

		// Selecting All inputs
		this.selectAll.addEventListener('change', () => {
			this.log(this.selectItem);
			for (let i = 0; i < this.selectItem.length; i++) {
				if (this.selectAll.checked) {
					this.selectItem[i].checked = true;
					document.querySelector('.m-filter').classList.add('has-buttons');
					this.selectAll.parentNode.parentNode.parentNode.classList.add('has-search');
					this.filterSave.classList.add('is-button');
				} else {
					this.selectItem[i].checked = false;
					this.selectAll.parentNode.parentNode.parentNode.classList.remove('has-search');
					document.querySelector('.m-filter').classList.remove('has-buttons');
					this.filterSave.classList.remove('is-button');
				}
			}
		});
	}

	isChecked() {
		let isChecked = false;
		this.selectItem.forEach((el) => {
			if (el.checked) {
				isChecked = true;
			}
		});
		return isChecked;
	}
}

export default Filter;
